export default __webpack_public_path__ + "static/media/Vesting_ICON.75ba71ef.svg";